export const getConditionalFieldsToClean = <T extends Record<string, any>>(
  fields: Array<{
    field: string;
    conditional?: {
      field: string;
      value: string;
    };
  }>,
  filters: T,
): string[] => {
  const conditionalFields = fields.filter((f) => f.conditional);

  if (!conditionalFields.length) return [];

  const fieldsToClean: string[] = [];

  conditionalFields.forEach((field) => {
    const parentValue = filters[field.conditional!.field];
    const expectedValue = field.conditional!.value;

    const matches = (val: any): boolean => {
      if (!val) return false;
      if (Array.isArray(val)) {
        return val.some((v: any) => matches(v));
      }
      const compareValue =
        typeof val === "object" && val !== null ? val.id : val;
      return compareValue === expectedValue;
    };

    if (!matches(parentValue) && filters[field.field] !== null) {
      fieldsToClean.push(field.field);
    }
  });

  return fieldsToClean;
};
